import React, { useEffect, useState } from "react";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import styles from "./CustomPageTextTemplate.module.scss";
import classNames from "classnames/bind";
import { useAppDispatch } from "~/redux/hooks";
import FormInput from "~/components/common/form/formInput/FormInput";
import FormInpuEditor from "~/components/common/form/formInpuEditor/FormInpuEditor";
import PrimaryButton from "~/components/common/primary-button/PrimaryButton";
import OutlinedButton from "~/components/common/outlined-button/OutlinedButton";
import { BasicEstimateTemplateFormData } from "~/utils/interface/estimateSetting";
import { handleCreateIntroductionTemplate } from "~/thunks/estimate-setting/estimateSettingThunk";
import { estimateSettingActions } from "~/thunks/estimate-setting/estimateSettingSlice";
import { notify } from "~/utils/helper";

dayjs.extend(relativeTime);
const cx = classNames.bind(styles);

interface CustomPageTextTemplateProps {
    templateName?: string;
    templateType?: string;
    location?: string;
    onCancel?: () => void;
}

const CustomPageTextTemplate = (props: CustomPageTextTemplateProps) => {
    const { templateName: nameFromParent, templateType, onCancel } = props;
    const dispatch = useAppDispatch();
    const [loading, setLoading] = useState(false);

    const [formData, setFormData] = useState<BasicEstimateTemplateFormData>({
        templateName: "",
        templateDescription: "",
    });

    useEffect(() => {
        if (nameFromParent != null && nameFromParent !== "") {
            setFormData((prev) => ({ ...prev, templateName: nameFromParent }));
        }
    }, [nameFromParent]);

    const handleUpdateFormData = (update: Partial<BasicEstimateTemplateFormData>) => {
        const data: BasicEstimateTemplateFormData = { ...formData, ...update };
        setFormData({
            templateName: data.templateName ?? "",
            templateDescription: data.templateDescription ?? "",
        });
    };

    const handleAddCustomPageText = () => {
        setLoading(true);
        dispatch(
            handleCreateIntroductionTemplate({
                templateName: formData.templateName ?? "",
                description: formData.templateDescription ?? "",
                type: templateType ?? "",
                content: formData.templateDescription ?? "",
            })
        )
            .unwrap()
            .then(() => {
                dispatch(estimateSettingActions.changeNeedRefreshDataEstimateTemplates(true));
                onCancel?.();
                notify("success", "Create custom page text template successfully");
            })
            .catch(() => {
                notify("error", "Create custom page text template failed");
            })
            .finally(() => {
                setLoading(false);
            });
    };

    return (
        <div className={cx("custom-page-text-template-container")}>
            <div className={cx("template-name-block")}>
                <FormInput
                    name="Template Name"
                    text="Template Name"
                    isViewMode={false}
                    placeholder="Template Name"
                    inputkey="templateName"
                    value={formData.templateName ?? ""}
                    height="56px"
                    onChange={(e) => handleUpdateFormData({ templateName: e.target.value })}
                />
            </div>

            <div className={cx("template-info")}>
                <h3 className={cx("template-info-title")}>Custom Page Text</h3>
                <div className={cx("button-container")}>
                    <OutlinedButton
                        title="Cancel"
                        onClick={() => onCancel?.()}
                        className={cx("cancel-button")}
                    />

                    <PrimaryButton
                        title="Add Custom Page Text"
                        onClick={handleAddCustomPageText}
                        className={cx("add-custom-page-text-button")}
                        disabled={loading}
                    />
                </div>
            </div>

            <div className={cx("template-description-block")}>
                <FormInpuEditor
                    name={"templateDescription"}
                    text={""}
                    placeholder={""}
                    inputkey={"templateDescription"}
                    value={formData?.templateDescription}
                    isViewMode={false}
                    errorMessage={""}
                    height="100%"
                    onChange={(value) => {
                        handleUpdateFormData({ templateDescription: value });
                    }}
                />
            </div>
        </div>
    );
};

export default CustomPageTextTemplate;